import { PurchasesOffering, PurchasesPackage } from 'react-native-purchases';

export interface LocalizedStrings {
  [locale: string]: string;
}

export interface OfferingMetadata {
  show_new_benefits?: boolean;
  title_strings?: LocalizedStrings;
  cta_strings?: LocalizedStrings;
  subtitle_strings?: LocalizedStrings;
  benefits?: string[];
  [key: string]: any;
}

export interface OfferingWithMetadata extends PurchasesOffering {
  metadata: OfferingMetadata;
}

export interface UseOfferingsResult {
  offerings: PurchasesOffering | null;
  currentOffering: PurchasesOffering | null;
  metadata: OfferingMetadata;
  packages: PurchasesPackage[];
  isLoading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
}

export const DEFAULT_LOCALE = 'pt_BR';
export const FALLBACK_LOCALE = 'en_US';

export function getLocalizedString(
  strings: LocalizedStrings | undefined,
  locale: string = DEFAULT_LOCALE,
  fallback: string = ''
): string {
  if (!strings) return fallback;
  
  return strings[locale] || strings[FALLBACK_LOCALE] || Object.values(strings)[0] || fallback;
}
